import { IS_APP_DESKTOP, window } from '../../helpers/BrowserHelpers';
export default function download(url) {
  if (IS_APP_DESKTOP) {
    window.electron.ipcRenderer.send('download', {
      url: url
    });
  } else {
    return window.open(url, '_blank');
  }
}